import { ProductPrices } from 'palette/candidates';
import { formatProductPriceToSnakeCase } from '@common/Checkout/shared/components/CartItem/CartItemPriceV2/helpers';
import type { CartItemPrices } from '@common/Checkout/shared/components/CartItem/types';

interface CartItemPriceV2Props {
    productPrices: CartItemPrices;
    className?: string;
}

export function CartItemPriceV2({
    productPrices, className,
}: CartItemPriceV2Props) {
    return (
        <div className={className}>
            <ProductPrices
                productPrices={formatProductPriceToSnakeCase(productPrices)}
            />
        </div>
    );
}
